<template>
<div>
<v-form
   ref="form"
>
  <v-container fluid>
    <v-row justify="space-between" style="height: 102px;" class="text-left d-flex align-center">
      <v-col cols="7" class="text-left">
        <v-btn color="" class="mr-5" to="/stafflist"> 戻る</v-btn>
        <span v-if="is_admin">
        <DialogYuukyuuFuyo :staff_name="data.name" :staff_id="staff_id" style="display:inline-block;"></DialogYuukyuuFuyo></span>
      </v-col>


    </v-row>
  </v-container>

  <v-card class="pa-4 pb-10">
    <v-container fluid class="myform">

        <v-row>
            <v-col cols="3" class="text-left">
                <h3 class="">有休管理</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>スタッフ名(漢字)</div>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field v-model="data.sei" readonly class="gray" outlined></v-text-field>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field v-model="data.mei" readonly class="gray"  outlined></v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>スタッフ名(カナ)</div>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field readonly  class="gray" 
                v-model="data.sei_kana"
                outlined></v-text-field>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field readonly  class="gray" 
                v-model="data.mei_kana"
                outlined></v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>入社年月日</div>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field readonly  class="gray" 
                v-model="data.hire_date"
                outlined></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>有休残日数</div>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field readonly  class="gray" 
                v-model="data.yuukyuu"
                outlined></v-text-field>
            </v-col>
        </v-row>

<!--        <v-row>-->
<!--            <v-col cols="2" class="text-left" align-self="center">-->
<!--                <div>有休付与予定日/日数</div>-->
<!--            </v-col>-->
<!--            <v-col cols="2" align-self="end" class="pt-11">-->
<!--                <v-text-field :value="data.plan_date"  readonly  class="gray" outlined></v-text-field>-->
<!--            </v-col>-->
<!--            <v-col cols="2" align-self="end" class="pt-11">-->
<!--                <v-text-field :value="data.plan_days"  readonly  class="gray" outlined></v-text-field>-->
<!--            </v-col>-->
<!--        </v-row>-->

<!--        <v-row>-->
<!--            <v-col cols="2" class="text-left" align-self="center">-->
<!--                <div>有休消滅予定日/日数</div>-->
<!--            </v-col>-->
<!--            <v-col cols="2" align-self="end" class="pt-11">-->
<!--                <v-text-field :value="data.lost_date"  readonly  class="gray" outlined></v-text-field>-->
<!--            </v-col>-->
<!--            <v-col cols="2" align-self="end" class="pt-11">-->
<!--                <v-text-field :value="data.lost_days"  readonly  class="gray" outlined></v-text-field>-->
<!--            </v-col>-->
<!--        </v-row>-->

    </v-container>
  </v-card>
</v-form>



  <v-card class="mt-10 pa-10 pt-6 pb-10">
    <v-container fluid class="myform">
    <h3 class="text-left mb-6">付与・休暇履歴</h3>
    <v-data-table
      fixed-header
      :headers="headers"
      :items="records"
      :items-per-page="20"
      sort-by="calories"
      class="elevation-1"
      @click:row="rowClick"
    >
      <template v-slot:item.name="{ item }">
          <div v-html="item.name"></div>
      </template>
      <template v-slot:no-data>
      データがありません.
      </template>
    </v-data-table>
    </v-container>
  </v-card>


</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex';
import moment from 'moment';
import DialogYuukyuuFuyo from '@/components/DialogYuukyuuFuyo.vue';
/* eslint-disable */

moment.locale("ja");

export default {
components: {
    DialogYuukyuuFuyo
},

// datas
data() {
    return {
        staff_id: '',
        data:{
            sei: '',
            mei: '',
            sei_kana: '',
            mei_kana: '',
            hire_date: '',
            yuukyuu: '',
            plan_days: '',
            plan_date: '',
            lost_days: '',
            lost_date: '',
        },
        headers: [
          {
            text: 'スタッフ名',
            align: 'start',
            value: 'name',
          },
          { text: '付与／休暇', value: 'label' },
          { text: '付与日／休暇取得日', value: 'date' },
          { text: '有効期限', value: 'expiry_date' },
          { text: '日数', value: 'days' },
          { text: '残', value: 'nokori' },
          { text: '休暇種別・付与種別', value: 'type' },
          { text: '理由', value: 'reason' },
        ],
        records: [],
        dialog: false,
    }  // datas
},


methods: {

    rowClick(){
        console.log('rowClick()');
    },
    fuyo (item) {
      // 有休付与
      console.log(item);
    },


/*
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
*/

    // 初期化
    initialize () {

        axios.get('/yuukyuu/' + this.staff_id)
          .then( (res) => {

              console.group();
              console.log('%c /yuukyuu/' + this.staff_id, mycolor.api);
              console.log(res.data);
              console.groupEnd()

              if(res.data.status==="NG"){
                  location.href="/stafflist";
                  alert(res.data.msg);
                  return false;
              }

              this.data = res.data.staff;
              this.records = res.data.history;
              // todo: staffの中にまとめて良いのではないか
              this.data.plan_date = res.data.plan_date;
              this.data.plan_days = res.data.plan_days;
              this.data.lost_date = res.data.lost_date;
              this.data.lost_days = res.data.lost_days;

              return false;
          })
          .catch( (e) => {
              console.error(e);
          });
    },  // initialize

},  // methods


created () {
    console.log('%ccreated: YuukyuuView.vue', mycolor.created);
    this.staff_id = this.$route.params.id;
    this.initialize()
},

computed: {
    ...mapGetters(['user', 'user_name', 'is_admin']),
},  // computed

}


</script>

<style scoped>
.myform .row{
  max-height: 100px;
}
/deep/ .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
    height: 48px;
}
/deep/ .v-text-field.v-textarea:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
    height: unset !important;
}
/deep/ .v-input__append-inner{
    margin: 0 !important;
    margin: auto !important;
}
/deep/ .row + .row{
    margin-top: 0px;
}
/deep/ .mywhite .v-input__slot{
    background: #fff;
}
/deep/ .gray .v-input__slot{
    background:#F0F0F0 !important;
}
</style>
